export enum AmericanFootballTouchdownAttribute {
  Passing = 643,
  Rushing = 644,
  InterceptionReturn = 645,
  FumbleRecovery = 646,
  PuntReturn = 647,
  KickoffReturn = 648,
}
